import { ChangeDetectionStrategy, Component, Resource, signal } from '@angular/core';
import { EmptyStateComponent, TranslatePipe } from '@softline/ui-core';
import type { ILoadingOverlayParams } from 'ag-grid-enterprise';
import { ResourceContainerComponent } from '@softapps/core';

type NoRowsParams = ILoadingOverlayParams<any, any> & {
  dataSource?: Resource<any>;
  onReload?: () => void;
};

@Component({
  selector: 'soft-grid-no-rows',
  imports: [ResourceContainerComponent, EmptyStateComponent, TranslatePipe],
  template: `
    @if (resource(); as res) {
      <soft-resource-container [resource]="res"></soft-resource-container>
    } @else {
      <soft-ds-empty-state
        variant="empty"
        actionSize="md"
        [title]="('#SOFTAPPS_CORE.COMPONENTS.GRID.EMPTY_TITLE' | translate) ?? null"
        [description]="
          ('#SOFTAPPS_CORE.COMPONENTS.GRID.EMPTY_DESCRIPTION' | translate) ?? null
        "
        [actionLabel]="('#SOFTAPPS_CORE.COMPONENTS.GRID.RELOAD' | translate) ?? null"
        (action)="reload()"
      />
    }
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridNoRowsOverlay {
  readonly resource = signal<Resource<any> | undefined>(undefined);
  private onReload: (() => void) | null = null;

  agInit(params: NoRowsParams): void {
    this.resource.set(params.dataSource);
    this.onReload = params.onReload ?? null;
  }
  refresh?(params: NoRowsParams): void {
    this.resource.set(params.dataSource);
    this.onReload = params.onReload ?? null;
  }

  protected reload(): void {
    this.onReload?.();
  }
}
